export const requiredString = {
    type: String,
    required: true,
};

export const requiredObject = {
    type: Object,
    required: true,
};

export const requiredBool = {
    type: Boolean,
    required: true,
};
